var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "xbartable" }, [
    _c(
      "table",
      { attrs: { border: "0" } },
      [
        _c("tr", { staticClass: "th" }, [
          _c("td", [
            _vm._v(
              _vm._s(_vm.t("confirmation.details_list.table.unique_id_nocss"))
            ),
          ]),
          _c("td", [
            _vm._v(
              _vm._s(_vm.t("confirmation.details_list.table.confirmation_type"))
            ),
          ]),
          _c("td", [
            _vm._v(
              _vm._s(_vm.t("confirmation.details_list.table.entity_name"))
            ),
          ]),
          _c("td", [
            _vm._v(
              _vm._s(
                _vm.t("confirmation.details_list.table.addressee_entity_name")
              )
            ),
          ]),
          _c("td", [
            _vm._v(
              _vm._s(
                _vm.t("confirmation.details_list.table.balance_sheet_date")
              )
            ),
          ]),
          _c("td", [
            _vm._v(
              _vm._s(
                _vm.t(
                  "confirmation.details_list.table.number_of_days_since_received"
                )
              )
            ),
          ]),
        ]),
        _vm._l(_vm.tableData, function (v, k) {
          return _c("tr", { key: k, staticClass: "tr" }, [
            _c("td", [_vm._v(_vm._s(v.uniqueId))]),
            _c("td", [_vm._v(_vm._s(_vm.t(`confirmation_type._${v.isBank}`)))]),
            _c("td", [_vm._v(_vm._s(v.confirmationEntityName))]),
            _c("td", [_vm._v(_vm._s(v.addrEntityName))]),
            _c("td", [
              _vm._v(_vm._s(_vm._f("formatDate")(v.balanceSheetDateStamp))),
            ]),
            _c("td", [
              _vm._v(_vm._s(v.daysOfReceivedAndProcessedByAddressees)),
            ]),
          ])
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }